import React from 'react'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { loadAttendanceHeader, clearAttendanceHeader } from '../../common/attendances/actions'
import { Title } from '../components'
import AttendanceFeedbacksPdfForm from "../forms/AttendanceFeedbacksPdf";

class AttendanceFeedbacksPdf extends React.Component {
  componentDidMount() {
    const { match, attendance, loadAttendanceHeader } = this.props
    const { params } = match
    if (params.attendance && (!attendance._id || params.attendance !== attendance._id)) {
      loadAttendanceHeader(params.attendance)
    }
  }
  componentWillUnmount() {
    this.props.clearAttendanceHeader()
  }
  render() {
    const { match, viewer, user, attendance } = this.props
    const { params } = match

    const title = `${moment(attendance.date).format('D.M.YYYY')} (${attendance.companyName}, ${attendance.locationName}) - upload zpětných vazeb`

    return (
      <div>
        <Title message={title} />
        <aside className="breadcrumbs">
          <Link to="/attendances">Prezenční listiny</Link>
          <img src="/images/arrow.png" alt="arrow-right" />
          <span>{title}</span>
        </aside>
        {(['SUPERVISOR','ADMIN'].indexOf(viewer.role) > -1) &&
        <main className="form-page thin content">
          <AttendanceFeedbacksPdfForm viewer={viewer} attendance={attendance} />
        </main>
        }
      </div>
    )
  }
}

AttendanceFeedbacksPdf.propTypes = {
  match: React.PropTypes.object,
  viewer: React.PropTypes.object.isRequired,
  attendance: React.PropTypes.object.isRequired,
  loadAttendanceHeader: React.PropTypes.func.isRequired,
  clearAttendanceHeader: React.PropTypes.func.isRequired,
}

export default connect(state => ({
  viewer: state.users.viewer,
  attendance: state.attendances.current,
}), { loadAttendanceHeader, clearAttendanceHeader })(AttendanceFeedbacksPdf)



// WEBPACK FOOTER //
// ./src/browser/pages/AttendanceFeedbacksPdf.js